import React from 'react';
import Title from '../title-tile/titleTileComponent';

const DeliveryComments = (props) => {
  const setComments = (e) => {
    const comments = e.target.value;
    // Just 500 chars of comments allowed
    if (comments.length < 500) {
      props.setDeliveryComments(comments);
    }
  };

  return (
    <div className="order-details-section">
      <Title
          hide={false}
          message='Comentarios sobre el pedido (Opcional)'
          alignLeft={true}
      />
      <div className="order-details-form-group">
        <div className="order-details-input-wrapper">
          <div className="input-group">
            <div className="input-group-prepend">
              <span className="input-group-text">Observaciones</span>
            </div>
            <textarea
              onChange={setComments}
              className="form-control order-details-textarea"
              aria-label="Observaciones"
              maxLength="499"
              rows="3"
            ></textarea>
          </div>
          <small className="form-text text-muted">Máximo 500 caracteres</small>
        </div>
      </div>
    </div>
  );
};

export default DeliveryComments;
